export default {
    config: {
        defaultWidth: {
            default: 320
        },
    },
    default: {
        label: 'Comment'
    },
    unique: [],
    sort: 'comment',
    lang: {
        name: 'Comment',
        category: ['User', 'Collection'],
        description: 'Show full user comment attached to the game.',
        views: ['sheet'],
    },
    filters: ['comment.text', 'has.commented']
}